module.exports = __webpack_public_path__ + "static/assets/1dd5ca7d570fb4aa9a0297d0c56960ab.svg";